<template>
  <div>
    <slot>
      <div style="margin-top: 70px">
        <div class="threehead">
          <span>{{ p.name }}</span
          ><span
            ><router-link :to="'/frontend/goods/products?id='+p.id">View more</router-link
            ></span
          >
        </div>
        <div class="threemain">
          <swiper :options="screenWidth > 400 ? swiperoption : swiperoptions">
            <swiper-slide v-for="(i, index) in p.goods_list" :key="index">
              <div>
                <div>
                  <img :src="'https://admin.ulikechem.com'+i.image"/>
                </div>
                <div>
                  <div>FOB : ${{ i.updated_price }}/{{i.unit}}</div>
                  <div style="font-size: 12px">( Country of origin : {{i.yieldly}} )</div>
                  <div style="color:#333">Cas No : {{ i.serial_number }}</div>
                  <div>
                    <router-link style="color:#007aff" :to="(`/frontend/goods/products/detail?id=${i.id}&name=${i.product_name}`)">{{
                      i.product_name
                    }}</router-link>
                  </div>
                  <div>Price validity : {{ i.validtime }}</div>
                </div> 
              </div>
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev">
              <img src="@/../public/image/向左箭头.png" alt="" />
            </div>
            <div class="swiper-button-next" slot="button-next">
              <img src="@/../public/image/向右箭头.png" alt="" />
            </div>
          </swiper>
        </div>
      </div>
    </slot>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  name: "mainslot",
  props: ["p"],

  beforeMount() {
    const that = this;
    that.$nextTick(function () {
      window.screenWidth = document.body.clientWidth;
      that.screenWidth = window.screenWidth;
      if (that.screenWidth < 400) {
        // this.$set(that.swiperoption,  1);
      }
    });
  },
  data() {
    return {
      screenWidth: document.documentElement.clientWidth,
      imgsrc: true,
      swiperoption: {
        autoplay: false,
        loop: false,
        slidesPerView: 3,
        spaceBetween: 30,
        freeMode: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          1280: {
            slidesPerView: 2,
            spaceBetween: 0,
          },
        },
        on: {
          slideChangeTransitionEnd: function () {
            if (this.isEnd) {
              this.navigation.$nextEl.css("display", "none");
            } else {
              this.navigation.$nextEl.css("display", "block");
            }
          },
        },
      },
      swiperoptions: {
        autoplay: false,
        loop: false,
        slidesPerView: 1,
        spaceBetween: 30,
        freeMode: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on: {
          slideChangeTransitionEnd: function () {
            if (this.isEnd) {
              this.navigation.$nextEl.css("display", "none");
            } else {
              this.navigation.$nextEl.css("display", "block");
            }
          },
        },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.threefloor {
  .threehead {
    margin-bottom: 30px;
    > span:first-child {
      font-weight: bold;
      font-size: 24px;
      margin-right: 34px;
    }
    > span:first-child::before {
      content: "";
      display: inline-block;
      width: 1px;
      height: 18px;
      background: #4066d3;
      border: 1px solid #2a35c4;
      margin-right: 10px;
    }
    > span:last-child {
      font-size: 16px;
      color: #4066d3;
    }
  }
  .threemain {
    border: 1px solid #052535;
    overflow: hidden;
    white-space: nowrap;
    // position: relative;
    .swiper-slide {
      > div {
        display: inline-flex;
        white-space: pre-wrap;
        align-items: center;
        overflow: hidden;
        > div:first-child {
          width:40%;
          flex:none;
          text-align: center;
          padding:10px 0;
          padding-right:10px;
          > img {
            width:100%;
            vertical-align:middle;
          }
        }
        > div:nth-child(2) {
          flex:1;
          display: flex;
          padding:10px 0;
          padding-right:10px;
          flex-direction: column;
          font-size: 13px;
          > div:first-child {
            font-weight: bold;
            font-size: 16px;
            margin-bottom:12px;
          }
          > div:nth-child(2) {
            margin-bottom:12px;
          }
          > div:nth-child(3) {
            margin-bottom:4px;
          }
          > div:nth-child(4) {
            a{
              display: -webkit-box;
              overflow: hidden;
              text-overflow: ellipsis;
              -webkit-line-clamp:3;
              -webkit-box-orient: vertical;
              word-wrap: break-word;
              word-break: normal;
              min-height:54PX;
            }
            margin-bottom:12px;
          }
        }
      }
    }
    .swiper-button-prev,
    .swiper-button-next {
      --swiper-navigation-size: 50px;
      background: #b2b2b2;
      text-align: center;
      display: block;
      line-height: 50px;
      > img {
        width: 100%;
        // display: block;
        vertical-align: middle;
      }
      //修改按钮大小
    }
    .swiper-button-next:after,
    .swiper-button-prev:after {
      --swiper-navigation-size: 0;
    }
    .swiper-button-prev,
    .swiper-container-rtl .swiper-button-next {
      left: 0;
    }
    .swiper-button-next,
    .swiper-container-rtl .swiper-button-prev {
      right: 0;
    }
    .swiper-button-disabled {
      opacity: 0 !important;
    }
  }
}
// @media screen and (max-width: 1600px) {
//   .threefloor
//     .threemain
//     .swiper-slide
//     > div
//     > div:nth-child(2)
//     > div:nth-child(2) {
//     display: -webkit-box;
//     overflow: hidden;
//     text-overflow: ellipsis;
//     -webkit-line-clamp: 1;
//     -webkit-box-orient: vertical;
//   }
// }
// @media screen and (max-width: 1280px) {
//   .threefloor .threemain .swiper-slide > div > div:first-child {
//     width: 40%;
//     img {
//       width: 80%;
//     }
//   }
//   .threefloor .threemain .swiper-slide > div > div:nth-child(2) {
//     width: 60%;
//   }
// }
// @media screen and (max-width: 1024px) {
//   .threefloor .threemain .swiper-button-prev,
//   .threefloor .threemain .swiper-button-next {
//     --swiper-navigation-size: 30px;
//     line-height: 30px;
//   }
//   .threefloor .threemain .swiper-slide > div > div:nth-child(2) {
//     padding-right: 20px;
//     font-size: 12px;
//   }
//   .threefloor
//     .threemain
//     .swiper-slide
//     > div
//     > div:nth-child(2)
//     > div:nth-child(5) {
//     display: -webkit-box;
//     overflow: hidden;
//     text-overflow: ellipsis;
//     -webkit-line-clamp: 1;
//     -webkit-box-orient: vertical;
//   }
// }
@media screen and (max-width: 400px) {
  .threefloor .threehead > span:first-child {
    font-size: 18px;
    margin-right: 0;
  }
  .threefloor .threehead {
    display: flex;
    justify-content: space-between;
  }
}
</style>
